import { render, staticRenderFns } from "./MenuRecommendationsGenerate.vue?vue&type=template&id=5cffc7a7&scoped=true"
import script from "./MenuRecommendationsGenerate.vue?vue&type=script&lang=js"
export * from "./MenuRecommendationsGenerate.vue?vue&type=script&lang=js"
import style0 from "./MenuRecommendationsGenerate.vue?vue&type=style&index=0&id=5cffc7a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cffc7a7",
  null
  
)

export default component.exports